var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.progress)?_c('div',{staticClass:"bar bg-light w-100 fixed-top",style:({height: `${_vm.height}px`})}):_vm._e(),_c('div',{staticClass:"bar bg-success fixed-top",style:({width: `${_vm.progress}%`, height: `${_vm.height}px`})})])
}
var staticRenderFns = []

export { render, staticRenderFns }